import * as abuseAPI from '@adobe/edex/frontend/api/abuse';

const abuse = {
  namespaced: true,
  state: {
    abuse: [],
  },
  mutations: {
    setList(state, abuse) {
      state.abuse = abuse;
    },
  },
  actions: {
    create({ commit, state }, { entityID, entityType }) {
      return abuseAPI.create(entityID, entityType);
    },
    async list({ commit }) {
      const { status, data } = await abuseAPI.list();
      if (status === 200) {
        commit('setList', data);
      }
    },
  },
};

export default abuse;
